// extracted by mini-css-extract-plugin
export var copyableField = "_kl-4";
export var customerBadge = "_kl-0";
export var customerInfoTitle = "_kl-2";
export var details = "_kl-1";
export var dropdownContainer = "_kl-5";
export var dropdownImage = "_kl-6";
export var editAssigneeForm = "_kl-a";
export var editButton = "_kl-3";
export var email = "_kl-7";
export var hidden = "_kl-d";
export var input = "_kl-8";
export var saveButton = "_kl-b";
export var shopifyIcon = "_kl-c";
export var suggestionBadge = "_kl-e";
export var suggestionText = "_kl-f";
export var username = "_kl-9";